/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetPaygBillingSummarySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetPaygBillingSummaryRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetPaygBillingSummarySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetPaygBillingSummarySecurity$outboundSchema: z.ZodMiniType<
  GetPaygBillingSummarySecurity$Outbound,
  GetPaygBillingSummarySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getPaygBillingSummarySecurityToJSON(
  getPaygBillingSummarySecurity: GetPaygBillingSummarySecurity,
): string {
  return JSON.stringify(
    GetPaygBillingSummarySecurity$outboundSchema.parse(
      getPaygBillingSummarySecurity,
    ),
  );
}

/** @internal */
export type GetPaygBillingSummaryRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetPaygBillingSummaryRequest$outboundSchema: z.ZodMiniType<
  GetPaygBillingSummaryRequest$Outbound,
  GetPaygBillingSummaryRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getPaygBillingSummaryRequestToJSON(
  getPaygBillingSummaryRequest: GetPaygBillingSummaryRequest,
): string {
  return JSON.stringify(
    GetPaygBillingSummaryRequest$outboundSchema.parse(
      getPaygBillingSummaryRequest,
    ),
  );
}
